(function() {
  var DEFAULT_ENDPOINT = 'https://storefront.abokpower.com/api/v1/actions/report';
  // var DEFAULT_ENDPOINT = 'http://localhost:8080/api/v1/actions/report';
  var DEFAULT_THRESHOLD = 0.8;
  var DEFAULT_EXPOSURE_DURATION = 2000;
  var DEVICE_ID_STORAGE_KEY = 'abok_expose_device_id';
  var ATTRIBUTION_DOMAIN_STORAGE_KEY = 'abok_expose_attribution_domain';
  var ATTRIBUTION_DOMAIN_TIMESTAMP_STORAGE_KEY = 'abok_expose_attribution_domain_ts';
  var ATTRIBUTION_DOMAIN_MAX_AGE = 24 * 60 * 60 * 1000;
  var HOME_DOMAIN = 'home';
  var BANNER_DOMAIN = 'banner';
  var USAGE_SCENARIOS_DOMAIN = 'usage scenarios';
  var EXTRAL_DOMAIN = 'extral';

  // Normalize selector, single element, NodeList, HTMLCollection, or array to an element array.
  function isElement(target) {
    return target && target.nodeType === Node.ELEMENT_NODE;
  }

  function resolveElements(target) {
    if (typeof target === 'string') {
      return Array.prototype.slice.call(document.querySelectorAll(target));
    }

    if (isElement(target)) {
      return [target];
    }

    if (target instanceof NodeList || target instanceof HTMLCollection || Array.isArray(target)) {
      return Array.prototype.filter.call(target, isElement);
    }

    return [];
  }

  function getRandomId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'device-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  // Device id is persisted in localStorage; if storage is unavailable, use a temporary id.
  function getDeviceId() {
    try {
      var savedDeviceId = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);

      if (savedDeviceId) {
        return savedDeviceId;
      }

      var deviceId = getRandomId();
      window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
      return deviceId;
    }
    catch (error) {
      return getRandomId();
    }
  }

  function getMetaContent(name) {
    var meta = document.querySelector('meta[name="' + name + '"]');
    return meta ? meta.getAttribute('content') || '' : '';
  }

  function getUrlSource() {
    try {
      return new URLSearchParams(window.location.search).get('source') || '';
    }
    catch (error) {
      var match = window.location.search.match(/[?&]source=([^&]*)/);
      return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';
    }
  }

  function normalizeValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isUsageScenariosValue(value) {
    var normalized = normalizeValue(value).replace(/_/g, '-');

    return normalized === USAGE_SCENARIOS_DOMAIN ||
      normalized === 'usage' ||
      normalized === 'usage-scenarios' ||
      normalized === 'home-usage' ||
      normalized === 'home usage' ||
      normalized === 'usagescenarios';
  }

  function normalizeReportDomain(domain) {
    var normalized = normalizeValue(domain);

    if (normalized === BANNER_DOMAIN) {
      return BANNER_DOMAIN;
    }

    if (isUsageScenariosValue(normalized)) {
      return USAGE_SCENARIOS_DOMAIN;
    }

    return EXTRAL_DOMAIN;
  }

  function getSourceDomain(source) {
    var normalized = normalizeValue(source);

    if (!normalized) {
      return '';
    }

    return normalizeReportDomain(normalized);
  }

  function getStoredAttributionDomain() {
    try {
      var sessionDomain = window.sessionStorage.getItem(ATTRIBUTION_DOMAIN_STORAGE_KEY);

      if (sessionDomain) {
        return sessionDomain;
      }

      var storedAt = Number(window.localStorage.getItem(ATTRIBUTION_DOMAIN_TIMESTAMP_STORAGE_KEY));
      var localDomain = window.localStorage.getItem(ATTRIBUTION_DOMAIN_STORAGE_KEY);

      if (localDomain && storedAt && Date.now() - storedAt <= ATTRIBUTION_DOMAIN_MAX_AGE) {
        return localDomain;
      }

      return '';
    }
    catch (error) {
      return '';
    }
  }

  function clearStoredAttributionDomain() {
    try {
      window.sessionStorage.removeItem(ATTRIBUTION_DOMAIN_STORAGE_KEY);
      window.sessionStorage.removeItem(ATTRIBUTION_DOMAIN_TIMESTAMP_STORAGE_KEY);
      window.localStorage.removeItem(ATTRIBUTION_DOMAIN_STORAGE_KEY);
      window.localStorage.removeItem(ATTRIBUTION_DOMAIN_TIMESTAMP_STORAGE_KEY);
    }
    catch (error) {}
  }

  function setStoredAttributionDomain(domain) {
    try {
      var normalizedDomain = normalizeReportDomain(domain);
      var savedAt = String(Date.now());

      window.sessionStorage.setItem(ATTRIBUTION_DOMAIN_STORAGE_KEY, normalizedDomain);
      window.sessionStorage.setItem(ATTRIBUTION_DOMAIN_TIMESTAMP_STORAGE_KEY, savedAt);
      window.localStorage.setItem(ATTRIBUTION_DOMAIN_STORAGE_KEY, normalizedDomain);
      window.localStorage.setItem(ATTRIBUTION_DOMAIN_TIMESTAMP_STORAGE_KEY, savedAt);
    }
    catch (error) {}
  }

  function isHomePage() {
    if (document.body && document.body.classList.contains('template-index')) {
      return true;
    }

    return window.location.pathname.replace(/\/+$/, '') === '';
  }

  function isSameOriginReferrer() {
    if (!document.referrer) {
      return false;
    }

    try {
      return new URL(document.referrer).origin === window.location.origin;
    }
    catch (error) {
      return false;
    }
  }

  function isReferrerHomePage() {
    if (!document.referrer) {
      return false;
    }

    try {
      var referrerUrl = new URL(document.referrer);

      return referrerUrl.origin === window.location.origin &&
        referrerUrl.pathname.replace(/\/+$/, '') === '';
    }
    catch (error) {
      return false;
    }
  }

  function syncAttributionDomainFromUrl() {
    if (isHomePage()) {
      clearStoredAttributionDomain();
      return;
    }

    var sourceDomain = getSourceDomain(getUrlSource());

    if (!sourceDomain) {
      if (!isSameOriginReferrer()) {
        clearStoredAttributionDomain();
      }

      return;
    }

    if (sourceDomain !== EXTRAL_DOMAIN ||
      !getStoredAttributionDomain() ||
      isReferrerHomePage() ||
      !isSameOriginReferrer()) {
      setStoredAttributionDomain(sourceDomain);
    }
  }

  function getAttributionDomain(domain, element) {
    if (isHomePage()) {
      return HOME_DOMAIN;
    }

    return getStoredAttributionDomain() ||
      getSourceDomain(getUrlSource()) ||
      EXTRAL_DOMAIN;
  }

  function getClickAttributionDomain(element) {
    if (!isHomePage()) {
      return getAttributionDomain(element?.dataset?.domain, element);
    }

    return normalizeReportDomain(element?.dataset?.domain || getUrlSource());
  }

  function persistClickDomain(element) {
    setStoredAttributionDomain(getClickAttributionDomain(element));
  }

  // Login email is injected by theme.liquid. Anonymous users leave this empty.
  function getUserEmail(config) {
    config = config || {};

    return config.userEmail ||
      config.email ||
      window.EXPOSE_USER_EMAIL ||
      getMetaContent('customer-email') ||
      '';
  }

  // user_id = device_id_user_email; anonymous users send device_id only.
  function getUserId(config) {
    config = config || {};

    if (config.userId) return config.userId;

    return getDeviceId();
    // return [
    //   getDeviceId(),
    //   getUserEmail(config)
    // ].filter(Boolean).join('_');
  }

  function bufferToHex(buffer) {
    return Array.prototype.map.call(new Uint8Array(buffer), function(byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('');
  }

  function fallbackHash(value) {
    var hash = 0;
    var text = String(value);

    for (var index = 0; index < text.length; index += 1) {
      hash = ((hash << 5) - hash) + text.charCodeAt(index);
      hash |= 0;
    }

    return Math.abs(hash).toString(16);
  }

  async function hashText(value) {
    if (window.crypto && window.crypto.subtle && window.TextEncoder) {
      var buffer = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(value)));
      return bufferToHex(buffer);
    }

    return fallbackHash(value);
  }

  // action can be a plain object or a function that derives payload fields from the element.
  function resolveAction(action, element) {
    if (typeof action === 'function') {
      return action(element);
    }

    return action || {};
  }

  // Build final report payload. Exposure defaults to action_type=exposure; clicks override it.
  async function buildExposureAction(action, element, config) {
    var resolvedAction = await Promise.resolve(resolveAction(action, element));
    var payload = Object.assign({
      action_type: 'exposure',
    }, resolvedAction || {});

    payload.user_id = payload.user_id || getUserId(config);
    payload.email = payload.email || getUserEmail(config);
    payload.item_id = payload.item_id || element?.dataset?.itemId || element?.dataset?.productId || element?.id || '';
    payload.domain = getAttributionDomain(payload.domain, element);

    // trace_id = hash(user_id + item_id + action_type + domain).
    payload.trace_id = payload.trace_id || await hashText([
      payload.user_id,
      payload.item_id,
      payload.action_type,
      payload.domain
    ].join(''));

    return payload;
  }

  function getReportBody(action) {
    return JSON.stringify({
      actions: [action]
    });
  }

  // Optional fallback for cross-origin endpoints without CORS.
  function isCrossOriginEndpoint(endpoint) {
    try {
      return new URL(endpoint, window.location.href).origin !== window.location.origin;
    }
    catch (error) {
      return false;
    }
  }

  function reportActionSilently(endpoint, body, config) {
    if (navigator.sendBeacon && config.useBeacon !== false) {
      var blob = new Blob([body], {
        type: 'text/plain;charset=UTF-8'
      });

      if (navigator.sendBeacon(endpoint, blob)) {
        return Promise.resolve({
          ok: true,
          beacon: true
        });
      }
    }

    return fetch(endpoint, {
      method: 'POST',
      mode: 'no-cors',
      keepalive: true,
      credentials: 'omit',
      headers: {
        'Content-Type': 'text/plain;charset=UTF-8'
      },
      body: body
    }).then(function() {
      return {
        ok: true,
        opaque: true
      };
    });
  }

  async function reportAction(action, options) {
    var config = options || {};
    var endpoint = config.endpoint || window.EXPOSE_REPORT_ENDPOINT || DEFAULT_ENDPOINT;

    if (action && typeof action === 'object') {
      action = Object.assign({}, action, {
        domain: getAttributionDomain(action.domain)
      });
    }

    var body = getReportBody(action);

    if ((config.noCors || window.EXPOSE_REPORT_NO_CORS) && isCrossOriginEndpoint(endpoint)) {
      return reportActionSilently(endpoint, body, config);
    }

    var response = await fetch(endpoint, {
      method: 'POST',
      credentials: config.credentials || 'same-origin',
      keepalive: config.keepalive === true,
      headers: Object.assign({
        'Content-Type': 'application/json'
      }, config.headers || {}),
      body: body
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  // Trigger after visibility stays at/above threshold for the required duration.
  function observe(target, action, options) {
    var elements = resolveElements(target);
    var config = options || {};
    var threshold = typeof config.threshold === 'number' ? config.threshold : DEFAULT_THRESHOLD;
    var exposureDuration = typeof config.duration === 'number' ? config.duration : DEFAULT_EXPOSURE_DURATION;
    var once = config.once === true;
    var reportedElements = new WeakSet();
    var visibleElements = new WeakSet();
    var exposureTimers = new WeakMap();

    if (!elements.length) {
      return {
        disconnect: function() {},
        unobserve: function() {}
      };
    }

    function clearExposureTimer(element) {
      var timer = exposureTimers.get(element);
      if (!timer) return;

      clearTimeout(timer);
      exposureTimers.delete(element);
    }

    // Track elements currently above the threshold and report only after they stay visible long enough.
    function handleVisibilityChange(element, visibleRatio, observer) {
      if (visibleRatio < threshold) {
        visibleElements.delete(element);
        clearExposureTimer(element);
        return;
      }

      if (visibleElements.has(element)) return;

      visibleElements.add(element);
      clearExposureTimer(element);
      exposureTimers.set(element, setTimeout(function() {
        exposureTimers.delete(element);
        if (!visibleElements.has(element)) return;
        handleExposure(element, observer);
      }, exposureDuration));
    }

    // Send the exposure report. once=true makes each element report at most once.
    function handleExposure(element, observer) {
      if (once && reportedElements.has(element)) return;

      reportedElements.add(element);

      buildExposureAction(action, element, config)
        .then(function(payload) {
          return reportAction(payload, config).then(function(result) {
            if (typeof config.onSuccess === 'function') {
              config.onSuccess(result, element, payload);
            }
          }).catch(function(error) {
            if (!once) {
              reportedElements.delete(element);
            }

            if (typeof config.onError === 'function') {
              config.onError(error, element, payload);
              return;
            }

            console.warn('Exposure report failed:', error);
          });
        })
        .catch(function(error) {
          if (!once) {
            reportedElements.delete(element);
          }

          if (typeof config.onError === 'function') {
            config.onError(error, element);
            return;
          }

          console.warn('Exposure action build failed:', error);
        });

      if (once) {
        observer.unobserve(element);
      }
    }

    // Prefer native IntersectionObserver for visible-area ratio detection.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          handleVisibilityChange(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0, observer);
        });
      }, {
        root: config.root || null,
        rootMargin: config.rootMargin || '0px',
        threshold: [threshold]
      });

      elements.forEach(function(element) {
        observer.observe(element);
      });

      return {
        disconnect: function() {
          elements.forEach(function(element) {
            visibleElements.delete(element);
            clearExposureTimer(element);
          });
          observer.disconnect();
        },
        unobserve: function(element) {
          visibleElements.delete(element);
          clearExposureTimer(element);
          observer.unobserve(element);
        }
      };
    }

    var fallbackTimer = null;

    // Fallback for older browsers: compute the element/viewport intersection ratio manually.
    function getVisibleRatio(element) {
      var rect = element.getBoundingClientRect();
      var width = rect.width || rect.right - rect.left;
      var height = rect.height || rect.bottom - rect.top;
      var area = width * height;

      if (!area) return 0;

      var visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
      var visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));

      return visibleWidth * visibleHeight / area;
    }

    function checkFallback() {
      elements.slice().forEach(function(element) {
        handleVisibilityChange(element, getVisibleRatio(element), fallbackObserver);
      });
    }

    function scheduleFallbackCheck() {
      if (fallbackTimer) return;

      fallbackTimer = setTimeout(function() {
        fallbackTimer = null;
        checkFallback();
      }, 100);
    }

    var fallbackObserver = {
      disconnect: function() {
        window.removeEventListener('scroll', scheduleFallbackCheck, true);
        window.removeEventListener('resize', scheduleFallbackCheck);
        clearTimeout(fallbackTimer);
        elements.forEach(clearExposureTimer);
      },
      unobserve: function(element) {
        visibleElements.delete(element);
        clearExposureTimer(element);

        var index = elements.indexOf(element);
        if (index !== -1) {
          elements.splice(index, 1);
        }

        if (!elements.length) {
          this.disconnect();
        }
      }
    };

    window.addEventListener('scroll', scheduleFallbackCheck, true);
    window.addEventListener('resize', scheduleFallbackCheck);
    checkFallback();

    return fallbackObserver;
  }

  class ExposeElement extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    // Start exposure monitoring and click reporting when the element enters the DOM.
    connectedCallback() {
      if (!this.exposeObserver) {
        this.exposeObserver = observe(this, this.buildAction.bind(this), this.buildOptions());
      }

      if (!this.clickListenerAttached) {
        this.addEventListener('click', this.handleClick, true);
        this.clickListenerAttached = true;
      }
    }

    // Release observers/listeners when the element is removed.
    disconnectedCallback() {
      if (this.clickListenerAttached) {
        this.removeEventListener('click', this.handleClick, true);
        this.clickListenerAttached = false;
      }

      if (this.exposeObserver) {
        this.exposeObserver.disconnect();
        this.exposeObserver = null;
      }
    }

    // Click reporting reuses the same payload builder and overrides action_type.
    handleClick(event) {
      if (this.shouldSkipInputClick(event)) return;

      persistClickDomain(this);

      var options = Object.assign({}, this.buildOptions(), {
        keepalive: true
      });

      setTimeout(() => {
        buildExposureAction(this.buildAction(this, {
          action_type: this.dataset.exposeActionType || 'click'
        }), this, options)
          .then(function(payload) {
            return reportAction(payload, options);
          })
          .catch(function(error) {
            console.warn('Click report failed:', error);
          });
      }, 0);
    }

    shouldSkipInputClick(event) {
      var target = event && event.target;
      if (target && target.closest && target.closest('[data-skip-parent-expose-click]')) return true;

      if (!this.hasAttribute('data-dedupe-input-click')) return false;

      var isInputClick = target && target.matches && target.matches('input[type="radio"], input[type="checkbox"]');

      if (isInputClick && this.lastLabelClickAt && Date.now() - this.lastLabelClickAt < 300) {
        this.lastLabelClickAt = 0;
        return true;
      }

      if (target && target.closest && target.closest('label')) {
        this.lastLabelClickAt = Date.now();
      }

      return false;
    }

    // Supports data-threshold/data-duration/data-once/data-endpoint for the current element.
    buildOptions() {
      var options = {};
      var threshold = Number(this.dataset.threshold);
      var duration = Number(this.dataset.duration);

      if (!Number.isNaN(threshold) && threshold > 0) {
        options.threshold = threshold;
      }

      if (!Number.isNaN(duration) && duration >= 0) {
        options.duration = duration;
      }

      if (this.hasAttribute('data-once')) {
        options.once = true;
      }

      if (this.dataset.endpoint) {
        options.endpoint = this.dataset.endpoint;
      }

      return options;
    }

    // Build business fields from data-* attributes; data-exinfo1 can override exinfo1.
    buildAction(element, overrides) {
      const clickType = element.dataset?.clickType || '';
      var exinfo = {
        source: getUrlSource(),
        url: window.location.href
      };

      if (clickType == 'check') {
        const checkbox = element.querySelector('input[type="checkbox"]');
        const ischecked = checkbox ? checkbox.checked : element.classList.contains('checked');
        const quantity = element.querySelector('.quantity-input')?.value;
        exinfo.checked = ischecked;
        quantity ? exinfo.quantity = quantity : '';
      }

      return Object.assign({
        item_id: element.dataset.exposeItemId || element.dataset.productId,
        domain: element.dataset.domain,
        exinfo1: element.dataset.exinfo1 || JSON.stringify(exinfo)
      }, overrides || {});
    }
  }

  class ExposeClickElement extends ExposeElement {
    // Click-only element: reuse the same payload builder without starting exposure observation.
    connectedCallback() {
      if (this.hasAttribute('data-manual-report')) return;

      if (!this.clickListenerAttached) {
        this.addEventListener('click', this.handleClick, true);
        this.clickListenerAttached = true;
      }
    }

    disconnectedCallback() {
      if (this.clickListenerAttached) {
        this.removeEventListener('click', this.handleClick, true);
        this.clickListenerAttached = false;
      }
    }
  }

  class ExposeViewElement extends ExposeElement {
    // Exposure-only element: reuse the same payload builder without binding click reporting.
    connectedCallback() {
      if (!this.exposeObserver) {
        this.exposeObserver = observe(this, this.buildAction.bind(this), this.buildOptions());
      }
    }

    disconnectedCallback() {
      if (this.exposeObserver) {
        this.exposeObserver.disconnect();
        this.exposeObserver = null;
      }
    }
  }

  window.Expose = window.Expose || {};
  window.Expose.listen = observe;
  window.Expose.observe = observe;
  window.Expose.reportAction = reportAction;
  window.Expose.buildExposureAction = buildExposureAction;
  window.Expose.getUserId = getUserId;
  window.Expose.getAttributionDomain = getAttributionDomain;
  window.Expose.persistClickDomain = persistClickDomain;
  window.Expose.Element = ExposeElement;
  window.Expose.ClickElement = ExposeClickElement;
  window.Expose.ViewElement = ExposeViewElement;

  if (!customElements.get('expose-element')) {
    customElements.define('expose-element', ExposeElement);
  }

  if (!customElements.get('expose-click-element')) {
    customElements.define('expose-click-element', ExposeClickElement);
  }

  if (!customElements.get('expose-view-element')) {
    customElements.define('expose-view-element', ExposeViewElement);
  }

  syncAttributionDomainFromUrl();
})();
